import React, { Component } from 'react';
import api, { API_ENDPOINTS, shippingApi } from '../../api/Api';
import {NotificationManager} from 'react-notifications';

const addressFieldIds = {user_name:'address-name', user_mobile:'address-mobile', user_pincode:'address-pincode', user_locality:'address-locality', user_address:'address-street', user_city:'address-city', user_state:'address-state', user_alternative_phone:'address-alternate', user_address_type:'inlineRadio1'};

class AddressNew extends Component {

    constructor(props) {
        super(props);
        const initialAddress = props.initialAddress || {};
        this.state = {
            address_id: initialAddress.address_id || initialAddress.id || '',
            user_name: initialAddress.user_name || initialAddress.name || '',
            user_mobile: initialAddress.user_mobile || initialAddress.mobile || '',
            user_pincode: initialAddress.user_pincode || initialAddress.postal_code || '',
            user_locality: initialAddress.user_locality || initialAddress.locality || '',
            user_address: initialAddress.user_address || initialAddress.address_line_1 || '',
            user_city: initialAddress.user_city || initialAddress.city || '',
            user_state: initialAddress.user_state || initialAddress.state || '',
            state_id: initialAddress.state_id || initialAddress.user_state_id || '',
            user_landmark: initialAddress.user_landmark || initialAddress.landmark || '',
            user_alternative_phone: initialAddress.user_alternative_phone || '',
            user_address_type: initialAddress.user_address_type || (initialAddress.address_type === 'Home' ? 'H' : initialAddress.address_type === 'Work' ? 'W' : ''),
            states: [],
            statesLoading: true,
            saving: false,
            is_default: Boolean(initialAddress.is_default),
            errors: {},
            touched: {},
        }   
    }

    componentDidMount() {
        this.loadStates();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialAddress !== this.props.initialAddress) {
            const initialAddress = this.props.initialAddress || {};
            this.setState({
                address_id: initialAddress.address_id || initialAddress.id || '',
                user_name: initialAddress.user_name || initialAddress.name || '',
                user_mobile: initialAddress.user_mobile || initialAddress.mobile || '',
                user_pincode: initialAddress.user_pincode || initialAddress.postal_code || '',
                user_locality: initialAddress.user_locality || initialAddress.locality || '',
                user_address: initialAddress.user_address || initialAddress.address_line_1 || '',
                user_city: initialAddress.user_city || initialAddress.city || '',
                user_state: initialAddress.user_state || initialAddress.state || '',
                state_id: initialAddress.state_id || initialAddress.user_state_id || '',
                user_landmark: initialAddress.user_landmark || initialAddress.landmark || '',
                user_alternative_phone: initialAddress.user_alternative_phone || '',
                user_address_type: initialAddress.user_address_type || (initialAddress.address_type === 'Home' ? 'H' : initialAddress.address_type === 'Work' ? 'W' : ''),
                is_default: Boolean(initialAddress.is_default),
                errors: {},
                touched: {},
            });
        }
    }

    extractList(payload, keys = ['data', 'states']) {
        if (Array.isArray(payload)) {
            return payload;
        }

        for (const key of keys) {
            if (Array.isArray(payload && payload[key])) {
                return payload[key];
            }
        }

        if (payload && payload.data && Array.isArray(payload.data.data)) {
            return payload.data.data;
        }

        return [];
    }

    async loadStates() {
        try {
            const response = await shippingApi.states();
            this.updateFields({ states: this.extractList(response.data), statesLoading: false });
        } catch (error) {
            console.error(error);
            this.updateFields({ statesLoading: false });
        }
    }

    updateStateFromMaster(stateId) {
        const selectedState = this.state.states.find((state) => `${state.id || state.state_id}` === `${stateId}`) || {};

        this.updateFields({
            state_id: stateId,
            user_state: selectedState.name || selectedState.state || selectedState.title || '',
        });
    }

    validate(values = this.state) {
        const errors = {};
        const text = field => String(values[field] || '').trim();
        if (text('user_name').length < 3) errors.user_name = 'Enter a name with at least 3 characters.';
        if (!/^\d{10}$/.test(text('user_mobile'))) errors.user_mobile = 'Enter a valid 10-digit mobile number.';
        if (!/^[1-9]\d{5}$/.test(text('user_pincode'))) errors.user_pincode = 'Enter a valid 6-digit pincode.';
        if (text('user_locality').length < 3) errors.user_locality = 'Enter your locality (at least 3 characters).';
        if (text('user_address').length < 5) errors.user_address = 'Enter your address (at least 5 characters).';
        if (text('user_city').length < 3) errors.user_city = 'Enter your city or town (at least 3 characters).';
        if (values.statesLoading) errors.user_state = 'Please wait for states to finish loading.';
        else if (text('user_state').length < 3 || (values.states.length > 0 && !values.states.some(state => `${state.id || state.state_id}` === `${values.state_id}`))) errors.user_state = 'Select a valid state.';
        if (text('user_alternative_phone') && !/^\d{10}$/.test(text('user_alternative_phone'))) errors.user_alternative_phone = 'Enter a valid 10-digit alternative phone number.';
        if (!['H', 'W'].includes(values.user_address_type)) errors.user_address_type = 'Choose Home or Work.';
        return errors;
    }

    updateFields(values) {
        this.setState(previous => {
            const next = {...previous, ...values};
            const validation = this.validate(next);
            return {...values, errors:Object.fromEntries(Object.keys(previous.touched).filter(field => validation[field]).map(field => [field, validation[field]]))};
        });
    }

    validationProps(field) {
        return {
            'aria-invalid': Boolean(this.state.errors[field]),
            'aria-describedby': this.state.errors[field] ? `${addressFieldIds[field]}-error` : undefined,
            onBlur: () => this.setState(previous => ({touched:{...previous.touched, [field]:true}, errors:{...previous.errors, [field]:this.validate(previous)[field]}})),
        };
    }

    fieldError(field) {
        return this.state.errors[field] ? <p id={`${addressFieldIds[field]}-error`} className="nw-address-form__error" role="alert">{this.state.errors[field]}</p> : null;
    }

    async submitAddress(){
        if (this.state.saving) return;

        const errors = this.validate();
        const first = Object.keys(errors)[0];
        this.setState({errors, touched:Object.fromEntries(Object.keys(addressFieldIds).map(field => [field, true]))}, () => {
            if (first) document.getElementById(addressFieldIds[first])?.focus();
        });
        if (first) return;

        const { address_id, user_name, user_mobile, user_pincode, user_locality, user_address, user_city, user_state, state_id, user_landmark, user_address_type}  = this.state ;

          const payload = {
            name: user_name.trim(),
            mobile: user_mobile.trim(),
            address_line_1: user_address.trim(),
            locality: user_locality.trim(),
            landmark: user_landmark.trim(),
            city: user_city.trim(),
            state: user_state.trim(),
            state_id,
            country_code: 'IN',
            postal_code: user_pincode.trim(),
            address_type: user_address_type === 'H' ? 'Home' : 'Work',
            is_default: this.state.is_default,
          };
            try {
                this.setState({ saving: true });
                this.props.onSavingChange?.(true);
                const response = address_id
                    ? await api.put(API_ENDPOINTS.addresses.detail(address_id), payload)
                    : await api.post(API_ENDPOINTS.addresses.create, payload);
                let resVal=response.data;
                if(response.status === 200 || response.status === 201){
                    NotificationManager.success(resVal.message || (address_id ? 'Address updated' : 'Address created'));
                    if (this.props.onSaved) {
                        this.props.onSaved();
                    }
                    this.props.showNewAddressBox(false);
                }else{
                    NotificationManager.error(resVal.message || 'Unable to save address');
                }
            } catch (error) {
                console.error(error);
                NotificationManager.error(error.response?.data?.message || 'Unable to save address');
            } finally {
                this.setState({ saving: false });
                this.props.onSavingChange?.(false);
            }

    }


    render() {
        const { address_id, user_name, user_mobile, user_pincode, user_locality, user_address, user_city, user_state, state_id, states, statesLoading, user_landmark, user_alternative_phone, user_address_type, is_default, saving }  = this.state ;
        const isEditing = !!address_id;
        return (
            <form className="ps-address__form" noValidate onSubmit={event => {event.preventDefault(); this.submitAddress();}}>
                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-name">Name</label>
                        <input {...this.validationProps('user_name')} required id="address-name" autoComplete="name" type="text" className="form-control ps-form__input" name="user_name" value={user_name} onChange={(event)=>this.updateFields({'user_name':event.target.value})}/>
                        {this.fieldError('user_name')}
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-mobile">Mobile number</label>
                        <input {...this.validationProps('user_mobile')} required id="address-mobile" autoComplete="tel-national" inputMode="tel" type="text" className="form-control ps-form__input" maxLength='10' name="user_mobile" value={user_mobile} onChange={(event)=>this.updateFields({'user_mobile':event.target.value})}/>
                        {this.fieldError('user_mobile')}
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-pincode">Pincode</label>
                        <input {...this.validationProps('user_pincode')} required id="address-pincode" autoComplete="postal-code" inputMode="numeric" type="text" className="form-control ps-form__input" maxLength='6' name="user_pincode" value={user_pincode} onChange={(event)=>this.updateFields({'user_pincode':event.target.value})}/>
                        {this.fieldError('user_pincode')}
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-locality">Locality</label>
                        <input {...this.validationProps('user_locality')} required id="address-locality" type="text" className="form-control ps-form__input" name="user_locality" value={user_locality} onChange={(event)=>this.updateFields({'user_locality':event.target.value})}/>
                        {this.fieldError('user_locality')}
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-12">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-street">Address (area and street)</label>
                        <textarea {...this.validationProps('user_address')} required id="address-street" rows={2} autoComplete="street-address" className="form-control ps-form__textarea" name="user_address" value={user_address} onChange={(event)=>this.updateFields({'user_address':event.target.value})}/>
                        {this.fieldError('user_address')}
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-city">City / town</label>
                        <input {...this.validationProps('user_city')} required id="address-city" autoComplete="address-level2" type="text" className="form-control ps-form__input" name="user_city" value={user_city} onChange={(event)=>this.updateFields({'user_city':event.target.value})}/>
                        {this.fieldError('user_city')}
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label nw-address-form__required" htmlFor="address-state">State</label>
                        {statesLoading ? (
                            <div className="ps-address__fieldPlaceholder" aria-label="Loading states" />
                        ) : states.length > 0 ? (
                            <select {...this.validationProps('user_state')} required id="address-state" autoComplete="address-level1" className="form-control ps-form__input" name="state_id" value={state_id} onChange={(event)=>this.updateStateFromMaster(event.target.value)}>
                                <option value="">Select state</option>
                                {states.map((state) => (
                                    <option key={state.id || state.state_id} value={state.id || state.state_id}>
                                        {state.name || state.state || state.title}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input {...this.validationProps('user_state')} required id="address-state" autoComplete="address-level1" type="text" className="form-control ps-form__input" name="user_state" value={user_state} onChange={(event)=>this.updateFields({'user_state':event.target.value, state_id: ''})}/>
                        )}
                        {this.fieldError('user_state')}
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label" htmlFor="address-landmark">Landmark (optional)</label>
                        <input id="address-landmark" type="text" className="form-control ps-form__input" name="user_landmark" value={user_landmark} onChange={(event)=>this.updateFields({'user_landmark':event.target.value})}/>
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label" htmlFor="address-alternate">Alternative phone (optional)</label>
                        <input {...this.validationProps('user_alternative_phone')} id="address-alternate" type="text" className="form-control ps-form__input" name="user_alternative_phone" value={user_alternative_phone} onChange={(event)=>this.updateFields({'user_alternative_phone':event.target.value})}/>
                        {this.fieldError('user_alternative_phone')}
                        </div>
                    </div>

                    <div className="nw-address-form__preferences">
                        <fieldset className="nw-address-form__type">
                            <legend className="nw-address-form__required">Address type</legend>
                            <div className="nw-address-form__typeOptions">
                            <label className={`nw-address-form__typeOption${user_address_type === 'H' ? ' is-selected' : ''}`}>
                            <input {...this.validationProps('user_address_type')} required className="form-check-input" type="radio" name="user_address_type" id="inlineRadio1" value="H" checked={user_address_type === 'H'} onChange={(event)=>this.updateFields({'user_address_type':event.target.value})}/>
                            <span>Home</span>
                            </label>
                            <label className={`nw-address-form__typeOption${user_address_type === 'W' ? ' is-selected' : ''}`}>
                            <input {...this.validationProps('user_address_type')} required className="form-check-input" type="radio" name="user_address_type" id="inlineRadio2" value="W" checked={user_address_type === 'W'} onChange={(event)=>this.updateFields({'user_address_type':event.target.value})}/>
                            <span>Work</span>
                            </label>
                            </div>
                            {this.fieldError('user_address_type')}
                        </fieldset>

                    <div className="ps-address__defaultOption">
                        <input
                            id="addressIsDefault"
                            type="checkbox"
                            checked={is_default}
                            onChange={(event) => this.setState({ is_default: event.target.checked })}
                        />
                        <label htmlFor="addressIsDefault">Make this my default delivery address</label>
                    </div>
                    </div>
                    
                        <div className="ps-address__formActions">
                            <button type="submit" className="nw-account__button" disabled={saving}>{saving ? 'Saving…' : isEditing ? 'Update address' : 'Save address'}</button>
                            <button type="button" className="nw-account__button nw-account__button--secondary" disabled={saving} onClick={()=>this.props.showNewAddressBox(false)}>Cancel</button>
                        </div>
            </form>
        );
    }
}

export default AddressNew;
